
<template>
  <!--新增版本-->
  <x-addEdit
    ref="addEdit"
    :formList="formList"
    :formKey="formKey"
    :addParam="addParam"
    :editParam="editParam"
    :detailParam="detailParam"
  >
  </x-addEdit>
</template>

<script>
import { fetchSelect } from '../../../utils/mixins';
let decoratorOptions = {
  appId: {
    rules: [{required: true, message: '请选择应用'}]
  },
  version: {
    validateTrigger: 'blur',
    rules: [
      {required: true, message: '请输入版本号'},
      {min: 2, max: 20, message: '版本号为2-20个字'}
    ]
  },
  code: {
    validateTrigger: 'blur',
    rules: [
      {required: true, message: '请输入code'},
      {min: 2, max: 10, message: 'code为2-10个字'}
    ]
  },
  content: {
    validateTrigger: 'blur',
    rules: [
      {required: true, message: '请输入更新说明'},
      {min: 2, max: 100, message: '更新说明为2-100个字'}
    ]
  },
  isForce: {valuePropName: 'checked', rules: []}
};
export default {
  mixins: [fetchSelect],
  name: 'addAppVersion',
  data () {
    return {
      detailInitValues: {},
      platform: '',
      formList: [
        {
          label: '应用',
          inputType: 'select',
          options: [],
          placeholder: '请选择应用',
          handle: this.appChange,
          props: ['appId', decoratorOptions.appId]
        },
        {
          label: '平台',
          inputType: 'select',
          options: [],
          placeholder: '请选择平台',
          handle: this.platformChange,
          props: ['osType', {
            rules: [{required: true, message: '请选择平台'}]
          }]
        },
        {
          label: '更新说明',
          inputType: 'textarea',
          options: [],
          placeholder: '请输入更新说明',
          props: ['content', decoratorOptions.content]
        },
        {
          label: 'APK',
          inputType: 'upload',
          options: [],
          placeholder: '',
          fileList: [],
          uploadParam: {
            url: '/common/upload',
            iconUrl: 'apkFile',
            iconName: 'fileName',

            accept: this.$store.state.apkAccept,
            uploadType: 5
          },
          beforeHandle: this.beforeHandle,
          props: ['sdkId', {
            rules: [{required: true, message: '请选择apk'}]
          }]
        },
        {
          label: '版本号',
          inputType: 'input',
          options: [],
          placeholder: '请输入版本号',
          blur: this.verifyVersion,
          props: ['version', decoratorOptions.version]
        },
        {
          label: '是否强制升级',
          inputType: 'checkbox',
          options: [],
          placeholder: '',
          props: ['isForce', decoratorOptions.isForce]
        }
      ],
      formKey: {
        appId: '',
        version: '',
        code: '',
        osType: '',
        content: '',
        sdkId: '',
        isForce: ''
      },
      addParam: {
        url: '/appVersion',
        reqHandle: this.addReqHandle, // this.reqHandle
        resHandle: this.addResHandle
      },
      editParam: {
        url: '/appVersion/',
        resHandle: '' // this.editResHandle
      },
      detailParam: {
        url: '/appVersion/',
        resHandle: this.detailResHandle
      }
    };
  },
  created () {
    let paramArr = [{index: 0, scope: 'formList', query: 'comu_app_type'}];
    this.dictionarySelect(paramArr);
    this.formList[1].options = this.$store.state.platformList;
  },
  methods: {
    /** 处理文件上传前事件
     * 当平台选择为小黑盒才自动设置版本号
     * 2020040802.bin => 20.04.08.02
     */
    beforeHandle (file, fileList) {
      if (this.platform === 3 && file.name) {
        let name = file.name;
        let year = name.slice(2, 4);
        let month = name.slice(4, 6);
        let date = name.slice(6, 8);
        let version = name.slice(8, 10);
        let str = [year, month, date, version];
        let versionStr = str.join('.');
        this.$refs.addEdit.form.setFieldsValue({ version: versionStr });
      }
      return true;
    },
    /* 应用类型 change */
    appChange (e, type) {
      type !== 'detail' && this.$refs.addEdit.form.resetFields(['osType']);
      let osType = this.formList.findIndex(el => el.props && el.props[0] === 'osType');
      // 当应用为门禁时，平台选项只要安卓和小黑盒选项
      e === '3'
        ? this.formList[osType].options = [this.$store.state.platformList[0], { label: '小黑盒', value: 3 }]
        : this.formList[osType].options = this.$store.state.platformList;
    },
    /* 平台类型 change */
    platformChange (e) {
      this.formList.forEach((el) => {
        let props = el.props;
        if (props && props[0] === 'sdkId') {
          let rule = props[1].rules[0];
          // 安卓：1，ios: 2, 小黑盒：3
          e === 2 ? rule.required = false : rule.required = true; // 为ios时sdk非必填
          e === 3 ? el.label = '固件' : el.label = 'APK'; // 为小黑盒时label为固件
          this.platform = e;
        }

        if (props && props[0] === 'version') {
          e === 3 ? el.disabled = true : el.disabled = false;
        }
      });
    },
    /* 验证版本号是否重复 */
    verifyVersion () {
      this.$refs.addEdit.form.validateFields(['version', 'appId', 'osType'], (err, values) => {
        if (err) { return; }
        if (Object.keys(this.detailInitValues).length &&
          values.version === this.detailInitValues.version &&
          values.appId === this.detailInitValues.appId &&
          values.osType === this.detailInitValues.osType) {
          return;
        }

        this.$post({
          url: '/appVersion/check',
          params: values
        }).then((res) => {
          if (res.code !== 200) this.$message.success(`${res.msg}`);
        });
      });
    },
    addReqHandle (res) {
      res.isForce ? res.isForce = 1 : res.isForce = 0;
      return res;
    },
    addResHandle (res) {
      this.$store.dispatch('delCachedRoute', 'addAppVersion');
      this.$message.success('新增成功');
      this.$router.go(-1);
    },
    reqHandle (param) {
      return param;
    },
    detailResHandle (data) {
      let formValues = {};
      for (let item in data) {
        if (this.formKey.hasOwnProperty(item)) {
          formValues[item] = data[item];
        }
      }
      data.isForce === 1 ? formValues.isForce = true : formValues.isForce = false;
      this.appChange(data.appId, 'detail');
      this.platformChange(data.osType);
      this.detailInitValues = {...formValues};

      return formValues;
    },
    editResHandle (res) {
      return res;
    }
  }
};
</script>
